import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
	interpolation: {
		// O i18next escapa o valor interpolado por padrão, mirando quem injeta a
		// tradução como HTML. Aqui quem renderiza é o React, que já escapa — o
		// resultado era escapar DUAS vezes e mostrar a entidade crua na tela:
		// "http:&#x2F;&#x2F;127.0.0.1:3056" no endereço do plugin. Vale para
		// qualquer valor com caractere especial (URL, caminho, e-mail com "&").
		//
		// É seguro porque nenhum texto de tradução vai para innerHTML: os pontos
		// com dangerouslySetInnerHTML no app (termos de uso, preview de
		// aniversário, destaque de busca) usam dados próprios, não t().
		escapeValue: false,
	},
});

export { i18n };
